// extracted by mini-css-extract-plugin
export default {"timezoneNote":"channel-schedule_timezoneNote_tJVv5"};